import './App.css';
import Home from './components/Home/home';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Project from './components/Projects/Project';
import Certify from './components/Certifications/Certify';
import Conform from './components/Contact/Conform';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
      <section>
      <Navbar/>
      <Home/>
      <About/>
      <Skills/>
      <Project/>
      <Certify/>
      <Conform/>
      <Footer/>
      </section>
    </Router>
  );
}

export default App;
